module.exports = __webpack_public_path__ + "static/assets/eb847f6f995f51fc77fa7b4a819a8178.png";